import axios from 'axios';
import { SAVE_LOAD_FUNCTIONS_BASE_URL } from '../config/api';

/**
 * Fetch token usage for a specific user.
 * @param {string} userId - The user ID to fetch token usage for.
 * @param {number} tokenThreshold - The token threshold value.
 * @returns {Promise<object>} - Resolves with token usage and percentage.
 */
const fetchTokenUsage = async (userId, tokenThreshold) => {
  if (!userId) {
    console.error('User ID is required to fetch token usage.');
    return { tokenUsage: 0, usagePercentage: 0 }; // Default fallback
  }

  try {
    const response = await axios.post(`${SAVE_LOAD_FUNCTIONS_BASE_URL}/api/saveLoadFunctionAppHttp`, {
      action: 'gettotalusage',
      tablePartition: 'userResume',
      userID: userId,
      tableName: 'userProfiles',
    });

    const tokenUsage = response.data.totalUsage || 0;
    const usagePercentage = Math.min((tokenUsage / tokenThreshold) * 100, 100); // Cap at 100%


    return { tokenUsage, usagePercentage };
  } catch (error) {
    console.error('Failed to fetch token usage:', error);
    return { tokenUsage: 0, usagePercentage: 0 }; // Fallback values on error
  }
};

export default fetchTokenUsage;
